var PROJ = (typeof PROJ === 'object') ? PROJ : {};
PROJ.pdp = {
    VAR: {},

    init: function () {
        var _this = this;

        $("body").on("click", ".quantity-wrap .quantity-btn", function (e) {
            e.preventDefault();
            var box = $(this).parent().find("input");
            if($(this).hasClass('min'))
            {
                if($(this).hasClass('zerook'))
                {
                    if (parseInt(box.val()) > 0) box.val(parseInt(box.val()) - 1);
                }else if (parseInt(box.val()) > 1) box.val(parseInt(box.val()) - 1);
            }else
            {
                box.val(parseInt(box.val()) + 1);
            }
            box.trigger("change");
        });

        $('body').on('click', '.product-form .variable',function (e){
            e.preventDefault();
            e.stopPropagation();
            if($(this).hasClass('active')) return;
            var thisform = $(this).parents('.product-form');
            var thisid = $(this).attr('varid');
            var thissellplan = $(this).attr('data-selling-plan')?$(this).attr('data-selling-plan'):"";

            thisform.find('.selling-plan-id').val(thissellplan);

            thisform.find('.variable').removeClass('active');
            $(this).addClass('active');
            // window.history.replaceState({ }, '', '?variant='+thisid);

            var varprice = $(this).parent().find('.var-price').html();
            console.log(varprice);
            thisform.find('.price-replace').html(varprice);
            thisform.find('form input[name="id"]').val(thisid);

            if($(this).hasClass('available'))
            {
                thisform.find('button').removeAttr('disabled');
            }else
            {
                thisform.find('button').attr('disabled','');
            }
            if($(this).attr('data-imgvar-id') != "")
            {
                var ind = $('[data-assign-var="'+$(this).attr('data-imgvar-id')+'"]').index();
                $('.acc-gal').find('.gallery-inside').flickity( 'select', ind );
                if($('.sl-main-gal').length) Flickity.data('.sl-main-gal').select(ind);
            }

            var loyal_points = parseInt($(this).attr('data-loypoint'));
            if(loyal_points > 0) $('#loyal-points').text(loyal_points);

            var newUrl = "?variant="+thisid;
            if(thissellplan != "") newUrl = newUrl+= "&selling_plan="+thissellplan;
            window.history.pushState(null, null, newUrl);


        });

        document.querySelectorAll('.opp-wrap .oitem').forEach((item) =>{
            item.addEventListener('click',(e) =>{
                e.preventDefault();
                document.querySelector('.opp-wrap .oitem.active').classList.remove('active');
                document.querySelectorAll('.js-option').forEach(e => e.classList.remove('active'));
                item.classList.add('active');


                const planset = document.querySelector('.'+item.getAttribute('data-link'));
                if(planset)
                {
                    planset.classList.add('active');
                    planset.querySelector('.sub-pro .sl-var').click();

                    $('.sl-product-form').attr('plantype',item.getAttribute('data-link'));

                }


            });
        })


        $('.selling-plan-change').on('change',function(e){
            e.preventDefault();
            $(this).parents('[data-selling-plan]').attr('data-selling-plan',$(this).val());
            var thisform = $(this).parents('.product-form');
            thisform.find('.selling-plan-id').val($(this).val());
        });

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('sub') === 'true') {
            $('.product-form [data-link="js-option-plan"]').trigger('click');
            document.querySelector('.js-option-plan .sub-pro .sl-var').click();
        }


    }
}
